import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import setupApp from '@/utils/setupApp'

setupApp(createApp(App)).then((app) => app.mount('#app'))
